// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1t-6";
export var headerCell = "_1t-2";
export var rowWrapper = "_1t-4";
export var stickyAggregationCell = "_1t-a";
export var stickyAggregationRow = "_1t-7";
export var stickyColumnCell = "_1t-9";
export var stickyColumnHeaderCell = "_1t-8";
export var table = "_1t-1";
export var virtualRowWrapper = "_1t-5";
export var virtualTableContainer = "_1t-0";
export var white = "_1t-3";